/* sk-cart-notice.js
   Per-item delivery labels in the cart drawer + aggregate banner refresh.
   Detection is TAG-based (same tags the server banner uses), looked up per
   product via /products/{handle}.js since /cart.js does not expose tags:
     - 'Pickup Only' / 'Local Only'  -> pickup / local delivery label
     - 'Ground Shipping Only'        -> ground shipping label
   Idempotent + observer-driven so it survives CartJS re-renders.
   Loaded as an external asset so the theme's inline-HTML minifier can't
   truncate it. */
(function () {
  var cartCache = null;
  var tagsByHandle = {};
  var fetching = false;

  function refreshSkRestrictionBanner() {
    try {
      var url = location.pathname + (location.search ? location.search + '&' : '?') + 'skts=' + Date.now();
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('cartRestrictionBanner');
          var current = document.getElementById('cartRestrictionBanner');
          if (current && fresh) { current.innerHTML = fresh.innerHTML; }
        })
        .catch(function () {});
    } catch (e) {}
  }

  function ensureTags(items) {
    var need = items.filter(function (it) { return it.handle && !(it.handle in tagsByHandle); });
    return Promise.all(need.map(function (it) {
      return fetch('/products/' + it.handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (p) { tagsByHandle[it.handle] = (p.tags || []).map(String); })
        .catch(function () { tagsByHandle[it.handle] = []; });
    }));
  }

  function labelFor(item) {
    var tags = tagsByHandle[item.handle] || [];
    var hasPickup = tags.indexOf('Pickup Only') !== -1 || tags.indexOf('Local Only') !== -1;
    var hasGround = tags.indexOf('Ground Shipping Only') !== -1;
    if (hasPickup) {
      return { text: '🛒 Free in-store pickup', cls: 'sk-item-tag sk-item-tag--pickup' };
    }
    if (hasGround) {
      return { text: '🛒 Free in-store pickup', cls: 'sk-item-tag sk-item-tag--ground' };
    }
    return null;
  }

  /* Idempotent: only touches the DOM when a label is missing or wrong. */
  function paint() {
    if (!cartCache || !cartCache.items) return;
    document.querySelectorAll('.mini_pr_list').forEach(function (list) {
      var itemLis = Array.prototype.slice.call(list.querySelectorAll('li')).filter(function (li) {
        return li.querySelector('.cart-prod-title');
      });
      cartCache.items.forEach(function (item, i) {
        var li = itemLis[i];
        if (!li) return;
        var titleBox = li.querySelector('.cart-prod-title');
        if (!titleBox) return;
        var existing = li.querySelector('.sk-item-tag');
        var want = labelFor(item);
        if (!want) { if (existing) existing.parentNode.removeChild(existing); return; }
        if (existing) {
          if (existing.textContent !== want.text) existing.textContent = want.text;
          if (existing.className !== want.cls) existing.className = want.cls;
        } else {
          var el = document.createElement('span');
          el.className = want.cls;
          el.textContent = want.text;
          titleBox.insertAdjacentElement('afterend', el);
        }
      });
    });
  }

  function syncAndPaint() {
    if (fetching) { paint(); return; }
    fetching = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartCache = cart;
        return ensureTags(cart.items);
      })
      .then(function () { fetching = false; paint(); })
      .catch(function () { fetching = false; });
  }

  function refreshAll() { refreshSkRestrictionBanner(); syncAndPaint(); }

  window.refreshSkRestrictionBanner = refreshSkRestrictionBanner;
  window.applySkItemTags = syncAndPaint;

  var paintTimer;
  function scheduleFromObserver() {
    clearTimeout(paintTimer);
    paintTimer = setTimeout(function () { paint(); }, 120);
  }

  function start() {
    var target = document.getElementById('cartDrawer') || document.getElementById('cartPopup') || document.body;
    var obs = new MutationObserver(scheduleFromObserver);
    obs.observe(target, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      if (e.target.closest('.mini_pr_list') || e.target.closest('.header-cart') ||
          e.target.closest('[data-cart-remove]') || e.target.closest('[data-cart-update]') ||
          e.target.closest('.add-to-cart') || e.target.closest('[name="add"]')) {
        setTimeout(refreshAll, 1200);
        setTimeout(refreshAll, 2600);
      }
    });
    syncAndPaint();
    [600, 1500, 3000, 5000].forEach(function (t) { setTimeout(syncAndPaint, t); });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
